module.exports = __webpack_public_path__ + "media/demo/analytic_page-559230f7.jpg";